import type { CardCategoryT, CardT, GameAreaScreenT, GameCompleteTradeScreenT } from '@/types/Game'
import { ref } from 'vue'

const activeGameAreaScreen = ref<GameAreaScreenT>('IDLE_SCREEN')
const formedWordCards = ref<CardT[]>([])
const cardToExchange = ref<CardT | null>(null)
const cardToTrade = ref<CardT | null>(null)
const tradeCardType = ref<CardCategoryT>('plan')
const tradeLetter = ref('')

const activeFinalisingTradeScreen = ref<GameCompleteTradeScreenT>('OFFER_OPTIONS_SCREEN')
const tradeOfferPlayerId = ref('')
const canCloseTradeCardOptions = ref(true)

const setActiveFinalisingTradeScreen = (screen: GameCompleteTradeScreenT) => {
  activeFinalisingTradeScreen.value = screen
}

const resetTradeSwap = () => {
  setActiveFinalisingTradeScreen('OFFER_OPTIONS_SCREEN')
  tradeOfferPlayerId.value = ''
}

const setActiveGameAreaScreen = (screen: GameAreaScreenT) => {
  activeGameAreaScreen.value = screen
}

const goToGameAreaScreen = () => {
  activeGameAreaScreen.value = 'IDLE_SCREEN'
  cardToExchange.value = null
  cardToTrade.value = null
  formedWordCards.value = []
  canCloseTradeCardOptions.value = true
}

export const useGameArea = () => {
  return {
    activeGameAreaScreen,
    setActiveGameAreaScreen,
    goToGameAreaScreen,
    formedWordCards,
    cardToExchange,
    cardToTrade,
    tradeCardType,
    tradeLetter,
    activeFinalisingTradeScreen,
    setActiveFinalisingTradeScreen,
    tradeOfferPlayerId,
    resetTradeSwap,
    canCloseTradeCardOptions
  }
}
